import { render, staticRenderFns } from "./BalanceAccount.vue?vue&type=template&id=76f1ac66"
import script from "./BalanceAccount.vue?vue&type=script&lang=ts"
export * from "./BalanceAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports